import React from "react";
import "./index.css";

const Solutions = ({ title, children, text, image, bgr, mod = "" }) => {
  return (
    <section className={`solutions ${mod}`}>
      <div className="container">
        <div className="solutions__body">
          <article className="solutions__content">
            <div className="solutions__left">
              <h2 className="solutions__title">
                <div className="solutions__bgr">
                  <img width="360" height="360" src={bgr} alt="" />
                </div>
                {title}
              </h2>
              {text &&
                text.map((p, index) => (
                  <p key={p + index} className="solutions__text">
                    {p}
                  </p>
                ))}
            </div>
            {children}
          </article>
          {image && (
            <div className="solutions__image">
              <img src={image} alt="" />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
